// Mock data for LG Law Office

export const firmInfo = {
  name: "LG Law Office",
  tagline: "Fighting for Your Rights",
  phone: "1(909)397-7260",
  email: "",
  address: {
    street: "P.O. Box 2769",
    city: "Pomona",
    state: "CA",
    zip: "91769",
    full: "P.O. Box 2769, Pomona, CA 91769"
  },
  hours: "Monday - Friday 8:00 am - 5:00 pm",
  mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3305.0877890876!2d-117.75072!3d34.063287!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2d6f9f5e5c8d%3A0x9f5e5c8d9f5e5c8d!2sPomona%2C%20CA%2091769!5e0!3m2!1sen!2sus!4v1234567890!5m2!1sen!2sus"
};

export const attorney = {
  name: "Lionel Giron",
  title: "Esq.",
  fullName: "Lionel Giron, Esq.",
  bio: "Lionel Giron is a dedicated personal injury attorney with years of experience fighting for the rights of injury victims in California. With a proven track record of successful case outcomes, Mr. Giron is committed to providing personalized attention and aggressive representation to every client. His expertise spans workers' compensation, auto accidents, slip and fall injuries, and rideshare accidents. Mr. Giron believes that everyone deserves access to quality legal representation, which is why he offers free consultations and works on a contingency fee basis – you don't pay unless we win your case.",
  image: "https://customer-assets.emergentagent.com/job_lglaw-injury/artifacts/16oi9ztz_lionelgiron.webp",
  credentials: [
    "Licensed California State Bar Attorney",
    "Member of California Employment Lawyers Association",
    "Specialized in Personal Injury Law",
    "Fluent in English and Spanish"
  ]
};

export const practiceAreas = [
  {
    id: 1,
    title: "Workers' Compensation",
    slug: "workers-compensation",
    icon: "Briefcase",
    iconImage: "https://customer-assets.emergentagent.com/job_lglaw-injury/artifacts/brfanqjr_first-aid-support-accident-at-work-of-worker-at-fa-2026-01-11-11-01-31-utc.jpg",
    shortDescription: "Injured at work? We help you get the compensation you deserve.",
    fullDescription: "If you've been injured on the job, California law entitles you to workers' compensation benefits. These benefits can cover medical expenses, lost wages, rehabilitation costs, and disability payments. Our experienced team will guide you through the complex claims process, ensuring you receive maximum compensation. We handle cases involving workplace accidents, repetitive stress injuries, occupational diseases, and work-related illnesses. Don't let your employer or their insurance company deny you the benefits you've earned.",
    image: "https://images.unsplash.com/photo-1633158832532-f71e9c7ac6d6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHw2fHxpbmp1cnl8ZW58MHx8fHwxNzY4NDk2NzI0fDA&ixlib=rb-4.1.0&q=85",
    benefits: [
      "Free case evaluation",
      "No upfront costs",
      "Maximum compensation",
      "Expert claim handling"
    ]
  },
  {
    id: 2,
    title: "Personal Injury",
    slug: "personal-injury",
    icon: "Heart",
    iconImage: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=400&h=300&fit=crop",
    shortDescription: "Injured due to someone else's negligence? Let us fight for you.",
    fullDescription: "Personal injury cases arise when you're hurt due to another person's negligence or intentional actions. Whether it's a slip and fall, dog bite, or premises liability case, you deserve compensation for your medical bills, lost income, pain and suffering, and emotional distress. Our firm has successfully represented countless clients in personal injury cases, securing millions in settlements and verdicts. We thoroughly investigate each case, work with medical experts, and build compelling arguments to maximize your recovery.",
    image: "https://images.unsplash.com/flagged/photo-1569948807383-bc995c4f6dd1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHw0fHxhY2NpZGVudHxlbnwwfHx8fDE3Njg0OTY3MTl8MA&ixlib=rb-4.1.0&q=85",
    benefits: [
      "24/7 availability",
      "Proven track record",
      "No win, no fee",
      "Aggressive representation"
    ]
  },
  {
    id: 3,
    title: "Auto Accidents",
    slug: "auto-accidents",
    icon: "Car",
    iconImage: "https://images.unsplash.com/photo-1713623311317-d3c43a4be4cf?w=400&h=300&fit=crop",
    shortDescription: "Car accident victim? Get the compensation you need to recover.",
    fullDescription: "Auto accidents can result in devastating injuries, mounting medical bills, and lost wages. California law requires drivers to carry insurance, but insurance companies often try to minimize payouts. Our auto accident attorneys fight back against unfair insurance practices. We handle all types of motor vehicle accidents including car crashes, motorcycle accidents, truck accidents, and pedestrian injuries. From gathering evidence to negotiating with insurance adjusters to taking cases to trial, we're with you every step of the way.",
    image: "https://images.unsplash.com/photo-1713623311317-d3c43a4be4cf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxjYXIlMjBhY2NpZGVudCUyMGRhbWFnZXxlbnwwfHx8fDE3Njg0OTY3MDh8MA&ixlib=rb-4.1.0&q=85",
    benefits: [
      "Free consultation",
      "Deal with insurance",
      "Fast settlement",
      "Trial experience"
    ]
  },
  {
    id: 4,
    title: "Slip and Fall Injuries",
    slug: "slip-and-fall",
    icon: "AlertTriangle",
    iconImage: "https://images.unsplash.com/photo-1516069677018-378515003435?w=400&h=300&fit=crop",
    shortDescription: "Injured on someone's property? They may be liable for your damages.",
    fullDescription: "Property owners have a legal duty to maintain safe premises. When they fail to fix hazards like wet floors, broken stairs, poor lighting, or uneven surfaces, and someone gets hurt, they can be held liable. Slip and fall injuries can be severe, causing fractures, head injuries, spinal damage, and chronic pain. We investigate the circumstances of your accident, gather evidence of negligence, and hold property owners accountable. Whether your injury occurred at a store, restaurant, office building, or private property, we can help.",
    image: "https://images.unsplash.com/photo-1516069677018-378515003435?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHw1fHxpbmp1cnl8ZW58MHx8fHwxNzY4NDk2NzI0fDA&ixlib=rb-4.1.0&q=85",
    benefits: [
      "Thorough investigation",
      "Liability experts",
      "Medical documentation",
      "Full compensation"
    ]
  },
  {
    id: 5,
    title: "Uber/Lyft Accidents",
    slug: "rideshare-accidents",
    icon: "Smartphone",
    iconImage: "https://images.unsplash.com/photo-1673187139181-795761a40ca1?w=400&h=300&fit=crop",
    shortDescription: "Injured in a rideshare accident? Special rules apply to your case.",
    fullDescription: "Accidents involving Uber, Lyft, and other rideshare services involve complex insurance and liability issues. Depending on whether the driver was logged into the app, en route to pick up a passenger, or carrying a passenger, different insurance policies may apply. Our attorneys understand these complexities and know how to navigate rideshare accident claims. We determine all available insurance coverage, identify liable parties, and pursue maximum compensation for your injuries. Don't let rideshare companies minimize your claim – we fight for full and fair recovery.",
    image: "https://images.unsplash.com/photo-1673187139181-795761a40ca1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHw0fHxjYXIlMjBhY2NpZGVudCUyMGRhbWFnZXxlbnwwfHx8fDE3Njg0OTY3MDh8MA&ixlib=rb-4.1.0&q=85",
    benefits: [
      "Insurance expertise",
      "Multi-party claims",
      "Quick response",
      "Maximum recovery"
    ]
  },
  {
    id: 6,
    title: "Dog Bites",
    slug: "dog-bites",
    icon: "AlertTriangle",
    iconImage: "https://customer-assets.emergentagent.com/job_lglaw-injury/artifacts/8mid5zzm_closeup-of-the-black-german-shepherd-barking-2026-01-07-07-24-33-utc.jpg",
    shortDescription: "Dog bite victim? California holds owners strictly liable for injuries.",
    fullDescription: "California has strict liability laws for dog bites, meaning dog owners are responsible for injuries their dogs cause, regardless of the dog's past behavior or the owner's knowledge of aggression. Dog bite injuries can be severe, causing permanent scarring, nerve damage, infections, and psychological trauma. Children are particularly vulnerable to serious dog attacks. Our experienced attorneys hold negligent dog owners accountable and pursue compensation for medical expenses, lost wages, pain and suffering, and emotional distress. We work with medical experts to document your injuries and ensure you receive full compensation for both physical and psychological damages.",
    image: "https://customer-assets.emergentagent.com/job_lglaw-injury/artifacts/8mid5zzm_closeup-of-the-black-german-shepherd-barking-2026-01-07-07-24-33-utc.jpg",
    benefits: [
      "Strict liability expertise",
      "Medical documentation",
      "Scar treatment coverage",
      "Psychological support"
    ]
  },
  {
    id: 7,
    title: "Employment Discrimination",
    slug: "employment-discrimination",
    icon: "Users",
    iconImage: "https://images.unsplash.com/photo-1656291857126-16125a3a1951?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHx3b3JrcGxhY2UlMjBkaXNjcmltaW5hdGlvbnxlbnwwfHx8fDE3Njg1MTMyOTZ8MA&ixlib=rb-4.1.0&q=85",
    shortDescription: "Facing workplace discrimination? We protect your rights and fight for justice.",
    fullDescription: "California and federal law prohibit discrimination based on race, color, religion, sex, national origin, age, disability, sexual orientation, gender identity, and other protected characteristics. If you've experienced discrimination in hiring, promotion, pay, job assignments, termination, or any other employment decision, you have legal rights. Our employment law attorneys fight against discriminatory practices and help victims recover compensation for lost wages, emotional distress, and punitive damages. We also handle retaliation claims when employers punish workers for reporting discrimination or participating in investigations. Don't let discrimination go unchallenged – we're here to protect your rights.",
    image: "https://images.unsplash.com/photo-1656291857126-16125a3a1951?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHx3b3JrcGxhY2UlMjBkaXNjcmltaW5hdGlvbnxlbnwwfHx8fDE3Njg1MTMyOTZ8MA&ixlib=rb-4.1.0&q=85",
    benefits: [
      "Federal & state law expertise",
      "Retaliation protection",
      "Lost wages recovery",
      "Punitive damages"
    ]
  },
  {
    id: 8,
    title: "Sexual Harassment",
    slug: "sexual-harassment",
    icon: "Shield",
    iconImage: "https://images.unsplash.com/photo-1625480857953-700f9cac1582?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxoYXJhc3NtZW50fGVufDB8fHx8MTc2ODUxMzMwM3ww&ixlib=rb-4.1.0&q=85",
    shortDescription: "Sexual harassment at work? We fight to protect your dignity and rights.",
    fullDescription: "Sexual harassment in the workplace is illegal and unacceptable. Whether you're experiencing quid pro quo harassment (where job benefits are conditioned on sexual favors) or hostile work environment harassment (unwelcome sexual conduct that creates an intimidating or offensive workplace), you have legal protections. California law provides strong remedies for sexual harassment victims, including compensation for emotional distress, lost wages, and punitive damages against employers who fail to prevent or address harassment. Our attorneys handle cases with sensitivity and discretion while aggressively pursuing justice. We also protect against retaliation when you report harassment. You deserve a safe workplace – let us help you fight back.",
    image: "https://images.unsplash.com/photo-1625480857953-700f9cac1582?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxoYXJhc3NtZW50fGVufDB8fHx8MTc2ODUxMzMwM3ww&ixlib=rb-4.1.0&q=85",
    benefits: [
      "Confidential handling",
      "Hostile environment claims",
      "Quid pro quo cases",
      "Retaliation defense"
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Maria Rodriguez",
    case: "Workers' Compensation",
    rating: 5,
    text: "After my workplace injury, I didn't know where to turn. Lionel Giron and his team took care of everything. They fought for my benefits while I focused on recovery. I received full compensation for my medical bills and lost wages. Highly recommend!",
    date: "2024-11"
  },
  {
    id: 2,
    name: "James Thompson",
    case: "Auto Accident",
    rating: 5,
    text: "I was rear-ended by a distracted driver and the insurance company tried to lowball me. LG Law Office stepped in and got me a settlement that was triple what the insurance initially offered. Professional, responsive, and truly cares about clients.",
    date: "2024-10"
  },
  {
    id: 3,
    name: "Sarah Chen",
    case: "Slip and Fall",
    rating: 5,
    text: "Excellent legal representation! I slipped on a wet floor at a grocery store and suffered a serious back injury. The store denied responsibility, but Mr. Giron's thorough investigation proved their negligence. I received a fair settlement that covered all my expenses.",
    date: "2024-09"
  },
  {
    id: 4,
    name: "Robert Martinez",
    case: "Uber Accident",
    rating: 5,
    text: "My Uber driver ran a red light and we were hit by another car. The insurance situation was confusing, but LG Law Office handled everything perfectly. They dealt with multiple insurance companies and got me full compensation. I couldn't have done it without them.",
    date: "2024-08"
  }
];

export const faqs = [
  {
    id: 1,
    question: "How much does it cost to hire LG Law Office?",
    answer: "We work on a contingency fee basis, which means you pay nothing upfront. We only get paid if we win your case. Our fee is a percentage of your settlement or verdict. If we don't win, you don't pay attorney fees. We offer free consultations to evaluate your case."
  },
  {
    id: 2,
    question: "How long do I have to file a personal injury claim in California?",
    answer: "California law typically allows two years from the date of injury to file a personal injury lawsuit. However, there are exceptions, and some cases have shorter deadlines. It's crucial to consult with an attorney as soon as possible to protect your rights and preserve evidence."
  },
  {
    id: 3,
    question: "What compensation can I receive for my injury?",
    answer: "Depending on your case, you may be entitled to compensation for medical expenses (past and future), lost wages, loss of earning capacity, pain and suffering, emotional distress, property damage, and in some cases, punitive damages. We thoroughly evaluate all aspects of your case to pursue maximum recovery."
  },
  {
    id: 4,
    question: "What should I do immediately after an accident?",
    answer: "Seek medical attention immediately, even if you don't think you're seriously injured. Document the scene with photos if possible. Get contact information from witnesses. Report the accident to authorities. Don't admit fault or sign anything from insurance companies. Contact LG Law Office as soon as possible for guidance."
  },
  {
    id: 5,
    question: "Will my case go to trial?",
    answer: "Most personal injury cases settle out of court through negotiation. However, we're always prepared to take your case to trial if necessary to get you fair compensation. Our trial experience gives us leverage in settlement negotiations, and insurance companies know we're not afraid to go to court."
  }
];

export const consultationBenefits = [
  {
    id: 1,
    title: "100% Free",
    description: "No obligation, no hidden fees. We review your case at absolutely no cost to you.",
    icon: "DollarSign"
  },
  {
    id: 2,
    title: "Case Evaluation",
    description: "Get expert legal advice on the strength of your case and potential compensation.",
    icon: "FileText"
  },
  {
    id: 3,
    title: "No Upfront Costs",
    description: "We work on contingency – you only pay if we win your case.",
    icon: "Shield"
  },
  {
    id: 4,
    title: "Fast Response",
    description: "We respond quickly to protect your rights and preserve crucial evidence.",
    icon: "Clock"
  }
];